import { Response, Account, apiAbortController } from '@ui/src';
import { Category, Revaluation } from '../types';

import api from '../../../api/api';

export const revaluationApi = api.injectEndpoints({
  endpoints: (build) => ({
    getRevaluationAccountsCategories: build.query<Response<Category>, string>({
      query: (query) => ({
        url: `/v1/accounts-categories?${query}`,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    getRevalutationAccountsList: build.query<Response<Account>, string>({
      query: (query) => ({
        url: `/v1/accounts${query}`,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    getRevalutationList: build.query<Response<Revaluation>, string>({
      query: (query) => ({
        url: `/v1/revaluation-transactions${query}`,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
  }),
});

export const {
  useGetRevaluationAccountsCategoriesQuery,
  useLazyGetRevalutationAccountsListQuery,
  useLazyGetRevalutationListQuery,
} = revaluationApi;

export const {
  endpoints: {
    getRevaluationAccountsCategories,
    getRevalutationAccountsList,
    getRevalutationList,
  },
} = revaluationApi;
